/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserAuthResponse } from '../entities/UserAuthResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userAuthResponseSchema = z.object({
  access_token: z.string(),
}) as unknown as ToZod<UserAuthResponse>